import './app.scss';
import Logo from './assets/images/logos/logo-white-small.png';
import LogoGreen from './assets/images/logos/trok-logo-greeen.png';

import React, { useEffect, useRef, useState } from 'react';
import { BrowserRouter, Route, Routes, useLocation } from 'react-router-dom';
import { Navbar } from './components/utils/navbar/navbar';
import { Home } from './components/home/home';
import { History } from './components/history/history';
import { Profile } from './components/profile/profile';
import { Register } from './components/profile/register/register';
import { Notification } from './components/utils/notification/notification';
import { WalletSetter } from './components/profile/wallet/wallet';

// device info
import { GlobalLoader } from './components/utils/loader/loader';
import { ModalError } from './components/utils/modal/modalError';
import { ModalWrapper } from './components/utils/modal-wrapper/modal-wrapper';
import { useAppDispatch, useAppSelector } from './features';
import { checkMobileStatus, getModalSignInUp, setIsNpos, wipeLocalStorage } from './store/AppSlice';
import { setPaymentChargeInfo, setPaymentCreationInfo } from './store/TransactionSlice';
import { modalTypeEnum } from './types/modal';

import { MetaMaskInpageProvider } from "@metamask/providers";
import { setBlockChainAddress, setIsComingFrmoBlockchain, setNetwork } from './store/RegisterSlice';
import { restoreWallet, setWallet, setChainId, disconnectWallet } from './store/WalletSlice';
import walletConnector from './features/wallet-connector';

const RouteChangeHandler: React.FC = () => {

  const dispatch = useAppDispatch();
  const location = useLocation();
  const prevLocation = useRef<string>(location.pathname);

  const handleRouteChange = () => {
    dispatch( setPaymentCreationInfo({}))
    dispatch( setPaymentChargeInfo({}))
  };

  useEffect(() => {
    if (prevLocation.current === '/home' && location.pathname !== '/home') {
      handleRouteChange();
    }
    prevLocation.current = location.pathname;
  }, [location]);

  useEffect(() => {

    dispatch(setIsNpos(localStorage.getItem('isNpos') === `true`))
    const usrAgent = window.navigator.userAgent.toLowerCase().includes("firefox");

    const handleListener = (e: Event) => {
      if (usrAgent) {
        const target = e.target as HTMLElement;
        const modalParent = target.closest(".modal");
        if (modalParent) modalParent.classList.toggle("firefox");
      }
    };
  
    const addListeners = () => {

      const inputs = document.querySelectorAll(".bottomPad");
  
      inputs.forEach((input) => {
        if (!input.hasAttribute("data-listener")) {
          input.setAttribute("data-listener", "true");
          input.addEventListener("focusin", handleListener);
          input.addEventListener("focusout", handleListener);
        }
      });
    };
    
    if (usrAgent) addListeners();
  
    const observer = new MutationObserver(() => addListeners());
  
    observer.observe(document.body, {
      childList: true,
      subtree: true,
    });
  
    return () => {
      observer.disconnect();
      document.querySelectorAll(".bottomPad").forEach((input) => {
        input.removeEventListener("focusin", handleListener);
        input.removeEventListener("focusout", handleListener);
      });
    };

  }, []);  

  return null;
};

declare global {
  interface Window{
    ethereum?:MetaMaskInpageProvider,
    tronWeb: {
      ready: boolean;
      defaultAddress: {
        base58: string;
      };
      toHex: (str: string) => string;
      trx: {
        sign: (msg: string) => Promise<string>;
        verifyMessage: (msg: string, signature: string, address: string) => boolean;
        signMessageV2: (msg:string) => string
      };
    };
  }
}

const App: React.FC = () => {

  const dispatch  = useAppDispatch();
  const modalType = useAppSelector(getModalSignInUp);
  
  useEffect( () => {
    dispatch(checkMobileStatus())
  }, [])


  useEffect(() => {

    if(!window.ethereum) return;

    window.addEventListener('message', function (e) {
        if (e.data.message && e.data.message.action == 'disconnect') {
          reset();
        }
    });

    window.ethereum
      .on("accountsChanged", checkAccountLength);

    return () => {
      window?.ethereum
        ?.removeListener("accountsChanged", checkAccountLength);

      window
       ?.removeEventListener('message', reset);
    }

  }, []);

  // estado global da carteira: restaura sessão e sincroniza com a extensão
  useEffect(() => {
    if (!walletConnector.isMetaMaskInstalled()) return;

    dispatch(restoreWallet());

    const unsubAccounts = walletConnector.onAccountsChanged((accounts) => {
      if (accounts.length > 0) dispatch(setWallet({ address: accounts[0] }));
      else dispatch(disconnectWallet());
    });

    const unsubChain = walletConnector.onChainChanged((chainId) => {
      dispatch(setChainId(chainId));
    });

    return () => {
      unsubAccounts();
      unsubChain();
    };
  }, []);

  const checkAccountLength = (accs:any) => {
    if(!window.ethereum) return;
    if(accs.length === 0) reset()
    return;
  }

  const reset = () => {
    window.location.href = '/';
    dispatch( setNetwork(''))
    dispatch( setIsComingFrmoBlockchain(false));
    dispatch( setBlockChainAddress(false))
    dispatch( wipeLocalStorage() )
  }

  return (
    <div className={`wrapper raleway wrapper-${modalType !== modalTypeEnum.none && modalType !== modalTypeEnum.deviceLogin && modalType !== modalTypeEnum.register ? 'hidden' : ''}`}>

      <div className="logo-wrapper">
        <img src={LogoGreen} alt="" />
      </div>

      <BrowserRouter>
        <RouteChangeHandler />

        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/home" element={<Home />} />
          <Route path="/profile" element={<Profile />} />
          <Route path="/history" element={<History />} />
          <Route path="/register" element={<Register />} />
          <Route path="/wallet" element={<WalletSetter />} />
          <Route path="*" element={<Home />} />
        </Routes>

        <Navbar />
        <Notification />
        <ModalError />
        <GlobalLoader />
        <ModalWrapper type={modalType} />
      </BrowserRouter>

    </div>
  );

};

export default App;
